import { opacify } from 'polished';
import styled, { css } from 'styled-components';

import { COLORS } from '../../styles/constants';
import Tooltip from '../Tooltip';

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
  padding: 13px;
  width: 100%;

  background-color: hsl(0, 0%, 100%);
  border-color: hsl(0, 0%, 80%);
  border-radius: 5px;
  border-style: solid;
  border-width: 1px;

  display: flex;
  align-items: center;

  transition: color 0.2s;
  transition: border-color 0.2s;

  ${(props) =>
    props.isErrored &&
    css`
      border-color: #c53030;
    `}

  ${(props) =>
    props.isFocused &&
    css`
      color: ${COLORS.primary};
      border-color: ${COLORS.primary};
    `}

  ${(props) =>
    props.isFilled &&
    css`
      color: ${COLORS.primary};
    `}

  input {
    flex: 1;
    background: transparent;
    border: 0;

    &::placeholder {
      color: ${opacify(-0.5, '#555')};
    }

    & + input {
      margin-top: 8px;
    }
  }

  svg {
    margin-right: 16px;
  }
`;

export const Error = styled(Tooltip)`
  height: 16px;
  margin-left: 16px;

  svg {
    margin: 0;
  }

  span {
    background: #c53030;
    color: #fff;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`;
